import Input from './Input';
import RadioGroup from './RadioGroup';
import Select from './Select';
import Checkbox from './Checkbox';
import BasicDatePicker from './BasicDatePicker';
import MultiSelect from './MultiSelect';
import File from './File';

const Controls = {
    Input,
    RadioGroup,
    Select,
    Checkbox,
    BasicDatePicker,
    MultiSelect,
    File,
};

export default Controls;
